import React, { useEffect, useState } from 'react';
import { SITE_CONFIG } from '../data/siteConfig';
import { Icon } from './icons';

// 모바일 OS 감지 — 티맵 앱 스킴 호출 분기에 사용
function detectMobile() {
  if (typeof navigator === 'undefined') return false;
  return /android|iphone|ipad|ipod/i.test(navigator.userAgent);
}

// 티맵 길찾기 URL — 모바일은 앱 스킴(tmap://) 직접 호출, PC는 웹 길찾기 페이지로
// goalname을 브랜드명으로 쓰면 T맵이 POI 매칭으로 동명 업체에 안내 (좌표 무시).
// 주소를 goalname으로 사용하여 POI 매칭 회피 → 좌표가 실제 destination이 되도록.
function buildTmapUrl({ lat, lng, address, isMobile }) {
  if (isMobile) {
    // T맵 표준 deep link: goalname / goalx(경도) / goaly(위도)
    return `tmap://route?goalname=${encodeURIComponent(address)}&goalx=${lng}&goaly=${lat}`;
  }
  return `https://tmap.life/route?goalname=${encodeURIComponent(address)}`;
}

const mapApps = (query) => {
  const q = encodeURIComponent(query);
  return {
    kakao: `https://map.kakao.com/?q=${q}`,
    naver: `https://map.naver.com/v5/search/${q}`,
  };
};

const btnBase = {
  display: 'inline-flex', alignItems: 'center', gap: 6,
  padding: '10px 16px', borderRadius: 'var(--radius)',
  fontSize: '0.9rem', fontWeight: 600, textDecoration: 'none',
  border: '1px solid', transition: 'transform 0.15s ease',
};

export default function MapPlaceholder() {
  const address = SITE_CONFIG.address;
  const apps = mapApps(address);
  const embedSrc = `https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed&language=ko`;

  // SSR 시에는 모바일 미감지 → CSR 마운트 후 결정 (티맵 URL이 PC↔모바일 다름)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => { setIsMobile(detectMobile()); }, []);
  const tmapUrl = buildTmapUrl({
    lat: SITE_CONFIG.coords.lat,
    lng: SITE_CONFIG.coords.lng,
    address,
    isMobile,
  });

  return (
    <div>
      {/* Address header */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16,
        padding: '16px 20px', background: 'var(--surface)',
        border: '1px solid var(--border)', borderRadius: 'var(--radius)',
      }}>
        <span style={{ color: 'var(--primary)', display: 'inline-flex' }}>
          <Icon name="MapPin" size={22} />
        </span>
        <span style={{ fontSize: '1rem', fontWeight: 600 }}>{address}</span>
      </div>

      {/* Map iframe */}
      <div style={{
        position: 'relative', width: '100%',
        aspectRatio: '16 / 9', maxHeight: 420,
        borderRadius: 'var(--radius)', overflow: 'hidden',
        border: '1px solid var(--border)', background: 'var(--surface)',
      }}>
        <iframe
          title={`${SITE_CONFIG.name} 위치 지도`}
          src={embedSrc}
          width="100%" height="100%" loading="lazy"
          style={{ border: 0, display: 'block' }}
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      {/* External map app buttons */}
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 16,
        justifyContent: 'center',
      }}>
        <a href={apps.kakao} target="_blank" rel="noopener noreferrer"
          style={{
            ...btnBase,
            background: '#FEE500', color: '#000', borderColor: '#FEE500',
          }}>
          <Icon name="MapPin" size={16} /> 카카오맵에서 열기
        </a>
        <a href={apps.naver} target="_blank" rel="noopener noreferrer"
          style={{
            ...btnBase,
            background: '#03C75A', color: '#fff', borderColor: '#03C75A',
          }}>
          <Icon name="Navigation" size={16} /> 네이버지도
        </a>
        <a href={tmapUrl}
          target={isMobile ? undefined : '_blank'}
          rel="noopener noreferrer"
          style={{
            ...btnBase,
            background: 'var(--surface-elev)', color: 'var(--text)',
            borderColor: 'var(--border)',
          }}>
          <Icon name="Car" size={16} /> 티맵 길찾기
        </a>
      </div>

      <p style={{
        textAlign: 'center', color: 'var(--text-dim)',
        fontSize: '0.8rem', marginTop: 12,
      }}>
        길찾기 버튼을 누르면 해당 지도 앱에서 바로 열립니다
      </p>
    </div>
  );
}
